export const QUOTES_POST = 'mac/FETCH_QUOTES_POST';
export const SEARCH_FOR_CONTACT_POST = 'mac/FETCH_SEARCH_FOR_CONTACT_POST';
export const REFUND_PDF = 'mac/FETCH_REFUND_PDF';
export const CART_INVOICE_PDF = 'mac/FETCH_CART_INVOICE_PDF';
export const ORDER_PDF = 'mac/FETCH_ORDER_PDF';
export const EDITED_CART_ORDER = 'mac/FETCH_CART_ORDER';
export const ORDER_JSON_GET = 'mac/FETCH_ORDER_JSON';
export const QUOTE_DELETE = 'mac/QUOTE_DELETE';
export const PO_NUMBER_UPDATE_MODAL_OPEN = 'mac/PO_NUMBER_UPDATE_MODAL_OPEN';
export const PO_NUMBER_UPDATE_MODAL_CLOSE = 'mac/PO_NUMBER_UPDATE_MODAL_CLOSE';
export const CART_CLONE_QUOTE = 'mac/FETCH_CART_CLONE';
export const CART_CLEAR_CLONE_QUOTE = 'mac/CLEAR_CART_CLONE';
export const CART_COPY_FOR_EDITING = 'mac/FETCH_CART_COPY_FOR_EDITING';
export const VERIFICATION_HASH = 'mac/VERIFICATION_HASH';
export const SINGLE_ORDER = 'mac/SINGLE_ORDER';
